module.exports = __webpack_public_path__ + "static/media/Lesson-8-13-It-Pays-to-Plan-Gods-Way.b3a7415d.pdf";